/**
 * Img to BG
 */
(function($) {
  var s,
  img2bg = {
    settings: {
      imgs: $('.js-imgbg'),
    },
    init: function() {
      s = this.settings;
      this.bindEvents();
    },
    bindEvents: function(){
      s.imgs.each(function() {
        var imageUrl = $(this).find('img').attr('src');
         $(this).css('background-image', 'url(' + imageUrl + ')');
      });
    },
  };
  img2bg.init();
})(jQuery);
